import Api from '@/services/Api'

export default {
	tiposOrdenesCompra(documento) {
		return Api().get('/tiposOrdenesCompra/'+documento)
	},
	tiposOrdenesAprobaciones(documento) {
		return Api().get('/tiposOrdenesAprobaciones/'+documento)
	},
	tiposOrdenesAprobador(documento) {
		return Api().get('/tiposOrdenesAprobador/'+documento)
	},
	grabaOrden(info) {
		return Api().put('grabaOrden',info)
	},
	apruebaOrden(id,estado,u_modifica) {
		return Api().put('apruebaOrden'+'/'+id+'/'+estado+'/'+u_modifica)
	},
	listaOrdenes(documento,userId,estado){
		return Api().get('listaOrdenes/'+documento+'/'+userId+'/'+estado)
	},
	consultaOrdenesManuales(documento){
		return Api().get('consultaOrdenes/'+documento)
	},
}
